// Kişisi olmayan bildirimin rozeti (9.26 · D-646).
//
// İade ve kazanç gibi olayları bir kişi değil nosubject'in sunucusu yazıyor.
// Bankanın mesajında bankanın logosu olduğu gibi, burada da nosubject'in logosu
// ("&", uygulama ikonundaki işaret) duruyor. Önceden içinde "?" olan bir daire
// çıkıyordu ve "kim olduğu bilinmiyor" gibi okunuyordu.
//
// Zemin ve işaret temadan: açık temada açık gri üstünde siyah, koyu temada koyu
// yüzey üstünde beyaz — ikondaki siyah-beyaz işaretin iki temadaki karşılığı.
// Ekran okuyucuya gizli: satırın anlamını başlık taşıyor, "ve işareti" diye
// okunan bir logo bir şey eklemez.
import React from 'react';
import { View } from './rn';
import Logo from './Logo';
import { useTheme } from '../theme/ThemeContext';

export default function SystemAvatar({ size }: { size: number }) {
  const colors = useTheme();
  return (
    <View
      testID="system-avatar"
      accessibilityElementsHidden
      importantForAccessibility="no-hide-descendants"
      style={{
        width: size,
        height: size,
        borderRadius: size / 2,
        backgroundColor: colors.gray100,
        alignItems: 'center',
        justifyContent: 'center',
        overflow: 'hidden',
      }}>
      <Logo size={Math.round(size * 0.56)} color={colors.black} />
    </View>
  );
}
